export function isRdfsSnapshot(source) {
    return source?.type === "snapshot" && "provider" in source && source.provider === "rdfs";
}
export function isCachedSubgraph(source) {
    return source?.type === "subgraph";
}
//# sourceMappingURL=concepts.js.map